import type {MouseEvent, ReactElement} from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import {ClickableDiv} from '@Components/clickable-div';
import {Icon} from '@Components/icon-v2';
import {FlatIconColor, FlatIconColorType, IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {Text, TextSize} from '@Components/text';

export interface SharedInTeamIndicatorProps {
  tooltipId?: string;
  className?: string;
  stopPropagationOnClick?: boolean;
}

export function SharedInTeamIndicator({tooltipId = 'shared-in-team-tooltip', className, stopPropagationOnClick = false}: SharedInTeamIndicatorProps): ReactElement<any> {
  const label = window.i18next.t('pmwjs_shared_in_team');

  const iconElement = (
    <Icon
      icon="icon-team"
      className={className}
      shape={IconShape.CIRCLE}
      type={IconType.FLAT}
      flatIconType={{color: FlatIconColor.PRIMARY, type: FlatIconColorType.DEFAULT}}
      size={IconSize.SIZE_ICON_12}
    />
  );

  const wrapped = stopPropagationOnClick ? (
    <ClickableDiv
      aria-label={label}
      className={className}
      onClick={(e: MouseEvent) => {
        e.stopPropagation();
      }}
    >
      {iconElement}
    </ClickableDiv>
  ) : (
    iconElement
  );

  return (
    <OverlayTrigger
      trigger={['hover', 'focus']}
      placement="top"
      delay={{show: 50, hide: 100}}
      overlay={
        <Tooltip id={tooltipId} className="spacing-m-b-3 spacing-m-l-1">
          <Text size={TextSize.XSMALL} val={label} />
        </Tooltip>
      }
    >
      {wrapped}
    </OverlayTrigger>
  );
}
